import aclStorage from "./aclStorageWrapper";

export default aclStorage;
